module.exports = __webpack_public_path__ + "img/center-content-2.15d080d2.svg";